import { useEffect, useMemo, useState } from 'react';

export const formatMessengerV2CallDuration = (startedAt, now = Date.now()) => {
  if (!startedAt) return '';
  const startedAtMs = new Date(startedAt).getTime();
  if (!Number.isFinite(startedAtMs)) return '';

  const seconds = Math.max(0, Math.floor((now - startedAtMs) / 1000));
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, '0')}`;
};

const useMessengerV2CallDuration = ({ enabled = true, startedAt = null } = {}) => {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!enabled || !startedAt) return undefined;

    setNow(Date.now());
    const timer = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(timer);
  }, [enabled, startedAt]);

  return useMemo(() => formatMessengerV2CallDuration(startedAt, now), [now, startedAt]);
};

export default useMessengerV2CallDuration;
